import { Grid } from "@mui/material";
import { useContext } from "react";
import { Control } from "react-hook-form";
import useLocales from "src/hooks/useLocales";

import Context from "../context";
import AppConfirmationLabel from "./AppConfirmationLabel";
import DBirthDateSelector from "./DBirthDateSelector/DBirthDateSelector";
import DTextInput from "./DTextInput";

// ----------------------------------------------------------------------

type Props = {
	totpNeeded?: boolean;
	userConfirmationNeeded?: boolean;
	control: Control<{}, any>;
};

export const FixedInputs = ({ totpNeeded, userConfirmationNeeded, control }: Props) => {
	const { params, selectedValue } = useContext(Context);
	const { translate } = useLocales();

	const entitySelected = params.find(
		(field) => field.visibility?.values?.find((i) => i === selectedValue)
	);
	const isUsername = selectedValue === "username";
	const filteredInputs = params.filter(
		(i) =>
			i.visibility === null && i.type !== "password" && i.name !== "login_type" && i.type !== "date"
	);
	const showPassword = params.some((field) => field?.type === "password");
	const dateParam = params.find((field) => field?.type === "date");

	if (totpNeeded) {
		return <DTextInput label={translate("connect_panel.2fa")} name='totp' />;
	}

	if (userConfirmationNeeded) {
		return <AppConfirmationLabel />;
	}

	return (
		<Grid container rowSpacing={2} maxWidth={{ xs: "auto", sm: 320 }}>
			{isUsername && (
				<Grid item xs={12}>
					<DTextInput label={entitySelected?.label} name={entitySelected?.name ?? ""} />
				</Grid>
			)}
			{filteredInputs.map((field, index) => (
				<Grid item xs={12} key={index}>
					<DTextInput label={field.label} name={field.name} />
				</Grid>
			))}
			{dateParam && (
				<Grid item xs={12}>
					<DBirthDateSelector control={control} name={dateParam.name} />
				</Grid>
			)}

			{showPassword && (
				<Grid item xs={12}>
					<DTextInput label={translate("login.password")} name='password' type='password' />
				</Grid>
			)}
		</Grid>
	);
};

export default FixedInputs;
